// extracted by css-extract-rspack-plugin
export default {"page":"DolurBZr4OIBOO_q","logo":"XQKOd0Rg4VYRoTa9"};